import { Cloud } from '@cast/shared-types';

import { Cluster } from 'types/cluster';

import {
  isEKSCluster,
  isGKECluster,
  isAKSCluster,
  isKOPSCluster,
  isROSACluster,
} from '@cast/shared-cluster-context-data-access';

export { getProviderNamespaceIdentifier as getUniqueIdentifier } from '@cast/features-cluster-shared-utils';

export const mapClusterToCloud = (cluster: Cluster): Cloud | undefined => {
  const supportedProvidersMap = [
    { validator: isEKSCluster, value: Cloud.aws },
    { validator: isGKECluster, value: Cloud.gcp },
    { validator: isAKSCluster, value: Cloud.azure },
    {
      validator: isKOPSCluster,
      value: (): Cloud | undefined => {
        return isKOPSCluster(cluster) ? cluster.kops.cloud : undefined;
      },
    },
    {
      validator: isROSACluster,
      value: (): Cloud | undefined => {
        return isROSACluster(cluster) ? cluster.openshift.cloud : undefined;
      },
    },
  ];

  return supportedProvidersMap.reduce((acc: Cloud | undefined, curr) => {
    if (curr.validator(cluster)) {
      return typeof curr.value === 'function' ? curr.value() : curr.value;
    }

    return acc;
  }, undefined);
};
